import { HoopsApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export const usePublishHoop = () => {
  const [publishHoop] = useAPIAction(
    HoopsApi,
    async (api, hoopCloudId: string) => {
      let data = await api.hoopsPublish({
        id: hoopCloudId,
      });
      return {
        successMessages: [],
        data,
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "",
    }
  );
  return useCallback(
    async (hoopCloudId: string) => {
      return await publishHoop(hoopCloudId);
    },
    [publishHoop]
  );
};
